import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import RenderizarProduto from '../Utils/RenderizarProduto';
import SelecionarCategoriaProduto from '../Utils/SelecionarCategoriaProduto';
import MenuRodape from './MenuRodape';
import PerfilParte from '../Utils/PerfilParte';

import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useParams, useNavigate} from 'react-router-dom';


const SelecionarProdutos = ({venda, setVenda}) => {
    const [avancada, setAvancada] = useState(false); 
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [produtos, setProdutos] = useState([]); // Produtos carregados
    const [filtroEstoque, setFiltroEstoque] = useState('todos'); // Filtro de estoque
    const [filtroCategoria, setFiltroCategoria] = useState(''); // Filtro de estoque
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    const { 
      buscarDados,
      crud,
      salvarDados,
      buscarDadosPorId,
      setLinks, 
      setBtns,
      setTitle,
      setTour,
    } = useProvider();
    const { get, loading } = crud || {};
    const navigate = useNavigate();
    
    setTitle('Produtos');

    const carregarLocal = async()=>{
      try{
        let response;
        if(query) {
          response = await buscarDados(
            'db_produtos',  
            (item) => {
                const searchValido = query
                  ? item.nome_do_produto?.toLowerCase().includes(query.toLowerCase())
                  : true;
                
                const filtroCat = filtroCategoria
                  ? !item.categoria?.nome_da_categoria ?true: item.categoria?.nome_da_categoria?.toLowerCase().includes(filtroCategoria.toLowerCase())
                  : true;
                
                let filtroAvancado = true;
                switch(filtroEstoque){
                  case 'todos':
                    filtroAvancado = item.is_ativo;
                    break;
                  case 'comEstoque':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && parseInt(item.quantidade_em_estoque || 0)>0;
                    break;
                  case 'promocao':
                    filtroAvancado = item.is_promocao;
                    break;
                  case 'estoqueBaixo':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && item.is_estoque_baixo;
                    break;
                  case 'semEstoque':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && parseInt(item.quantidade_em_estoque||0)===0;
                    break;
                  case 'inativo':
                    filtroAvancado = !item.is_ativo;
                    break;
                }
                
                  
                return searchValido && filtroCat && filtroAvancado;
            },
            20,
            "nome_do_produto",
            "asc",
          );
        }else{
          response = await buscarDados(
            'db_produtos',
            null,
            20,
            "nome_do_produto",
            "asc",
          );
        }
        
        if (response && response.length) {
          const base = response;
          setProdutos(base);
        }
      }catch(err){

      }finally{
        buscarProdutos(true);
      }
    }
    
    // Função para buscar produtos na API
    const buscarProdutos = async (novaBusca = false) => {
        let url = `/gvendas/produtos/?extra_info=true&tipo=agenda`;

        if (query) url += `&search=${query}`;
        if (!query) url += `&ordering=nome_do_produto`;
        if (filtroEstoque === 'todos') url += `&is_ativo=true`;
        else if (filtroEstoque === 'comEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque__gt=0`;
        else if (filtroEstoque === 'estoqueBaixo') url += `&is_ativo=true&controlar_estoque=true&is_estoque_baixo=true`;
        else if (filtroEstoque === 'semEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque=0`;
        else if (filtroEstoque === 'inativo') url += `&is_ativo=false`;
        if (filtroCategoria === 'sem_categoria') url += `&categoria__isnull=true`
        else if (filtroCategoria !== '') url += `&categorias=${filtroCategoria}`;

        if (novaBusca) {
            //setProdutos([]); // Limpa os produtos anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url, 'produtos');
          if(response && response.length){
            const novosProdutos = response[0].results; // Corrigir para acessar o resultado correto
            setProdutos((produtosAnteriores) => novaBusca ? novosProdutos : [...produtosAnteriores, ...novosProdutos]);
            setNextUrl(response[0].next);
            await salvarDados('db_produtos', novosProdutos);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar produtos"
          // });
        }finally{
          
        }
    };

    // Carrega os produtos ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      carregarLocal();
      //buscarProdutos(true); // Sempre faz uma nova busca
    }, [query, filtroEstoque, filtroCategoria]);
    
    useEffect(()=>{
      const carregarCheckout = async () => {
        try {
          const response = await buscarDadosPorId('local_registros', 'checkout');
          if (response) {
            if (!response?.venda?.cliente){
              navigate("/checkout/selecionar-cliente",{ replace:true });
            }
          } 
        } catch (error) {
          //alert(`Catx: ${error}`)
          //alert(error)
          console.error('Erro ao carregar checkout:', error);
        }
      };
      carregarCheckout();
      //alert(JSON.stringify(venda?.itens))
    },[venda])

    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    useEffect(() => {
        const tour = {
          id:"ckSelectProduto",
          lista:[
            {
              id: "#gvendas",
              titulo: `Adicionar produtos ao carrinho`,
              descricao: `Aqui nessa tela você vai informar os produtos que deseja incluir na venda.`,
              prev: false,
              next: true,
              finish: false
            },
            {
              id: "#btnCkPesquisarProduto",
              titulo: "Pesquisar Produto",
              descricao: "Aqui você pode digitar a pesquisa pelos produtos que deseja incluir na venda.",
              prev: true,
              next: true,
              finish: false
            },
            {
              id: "#btnCkFiltroProduto",
              titulo: "Filtrar Produto",
              descricao: "Aqui você pode seletionar os tipos de filtros da pesquisa que deseja.",
              prev: true,
              next: true,
              finish: false
            },
            {
              id: "#listaCkProdutos",
              titulo: "Lista de produtos",
              descricao: "Aqui vai aparecer o resultado da pesquisa, (+) adiciona produto e (-) retira produtos.",
              prev: true,
              next: true,
              finish: false
            },
            {
              id: "#btnCkAddProduto",
              titulo: "Adicionar Novo Produto",
              descricao: "Aqui você pode cadastrar um novo produto caso ainda não tenha ele cadastrado no estoque.",
              prev: true,
              next: false,
              finish: true
            },
          ]
        }
        setLinks([
          // { name: 'Nova Venda', to: '/vendas/novo' },
          // { name: 'Novo Produto', to: '/produtos/novo' },
          // { name: 'Novo Cliente', to: '/clientes/novo' },
          //{ name: 'Configurações', to: '/configuracoes' },
        ]);
        setBtns([
          //{icon:'bi-arrow-repeat', to:`/painel/sync`, id:"btnSync"},
          {icon:'bi-funnel'+(avancada?'-fill':''), id:"btnCkFiltroProduto", onClick:() => {setAvancada(!avancada); setFiltroEstoque('todos'); setFiltroCategoria('')}},
        ]);
        setTour(tour);
        return () => {setLinks([]); setBtns([]); setTour({});}
    }, [setLinks, setBtns, setTour, avancada, setAvancada]);
  
    
    const getCor = (e) => {
      if (e.controlar_estoque){
        if (e.quantidade_em_estoque > 0 && e.quantidade_em_estoque <= e.quantidade_minima_em_estoque){
          return 'orange';
        } else if (e.quantidade_em_estoque > 0){
          return 'green';
        } else{
          return 'red';
        }
      }
    }
    
    
    
    const getItem = (e) => {
      return venda?.itens?.find(x => x.produto.id === e.id);
    };
    
    
    
    const addOrUpdateProduto = async (e, q) => {
      const item = getItem(e);
      // Garantir que a venda e venda.itens estão definidos
      const itensVenda = venda.itens || [];
      const pagamentosVenda = venda.pagamentos || [];
      
      let listaAtualizada;
    
      if (item) {
        listaAtualizada = itensVenda.map((produto) =>
          produto.produto === item.produto
            ? { ...produto, quantidade: produto.quantidade + q }
            : produto
        );
      } else {
        // Adiciona um novo item à lista
        const novosProdutos = {
          produto: e,
          valor: e.preco_de_venda || 0,  // Garantir que o valor seja um número válido
          quantidade: q,
        };
        listaAtualizada = [...itensVenda, novosProdutos];
      }
    
      // Filtra os itens com quantidade > 0
      listaAtualizada = listaAtualizada.filter(x => x.quantidade > 0);
    
      // Calcular tPago com segurança (evitar valores não numéricos)
      const tPago = pagamentosVenda.filter(x => x.pago)
        .reduce((acc, x) => acc + parseFloat(x.valor || 0), 0);
    
      // Calcular tTotal
      const tTotal = listaAtualizada.reduce((acc, x) => 
        acc + (parseFloat(x.valor || 0) * parseFloat(x.quantidade || 0)), 0);
    
      // Evitar erro quando tPago for maior que tTotal
      if (tPago > tTotal) return;
    
      // Atualizar venda com a lista de itens atualizada
      // setVenda((prevVenda) => ({
      //   ...prevVenda,
      //   itens: listaAtualizada,
      // }));
      
      try{
        const response = await buscarDadosPorId('local_registros', 'checkout');
        const item = { 
            ...response,
            venda: {
              ...response?.venda,
              itens: listaAtualizada,
            },
        }
        await salvarDados('local_registros', {
          ...item,
          id:"checkout"
        });
        setVenda(item?.venda)
      }catch(err){
        
      }finally{
      }
      
    };
    
    
    
    const carrinho = () => {
      navigate('/checkout')
    }
    
    const botao = {
      onClick:carrinho, 
      text:'Prosseguir'
    }

    
    return (
        <>
            <PerfilParte cliente={venda?.cliente} />
            <div className={venda?.itens?.length>0?"pb-5":""}>
                <Form>
                    <Form.Group controlId="formBasicSearch">
                        <div className="input-group">
                            <Button id="btnCkAddProduto" variant="secondary" onClick={() => navigate('/produtos/novo')} disabled={loading}>
                                <i className="bi bi-plus"></i>Produto
                            </Button>
                            <Form.Control 
                                type="text" 
                                id="btnCkPesquisarProduto"
                                placeholder="Digite sua pesquisa" 
                                value={query} 
                                onChange={(e) => setQuery(e.target.value)} 
                            />
                            {!avancada &&(
                              <Button variant="secondary" onClick={() => buscarProdutos(true)} disabled={loading}>
                                  <i className="bi bi-search"></i>
                              </Button>
                            )}
                        </div>
                    </Form.Group>
                    {avancada && (
                      <>
                        <Form.Group controlId="formSelectStockFilter" className="mt-3">
                            <Form.Label>Filtrar por Estoque</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={filtroEstoque} 
                                onChange={(e) => setFiltroEstoque(e.target.value)}
                            >
                                <option value="todos">Todos</option>
                                <option value="comEstoque">Com Estoque</option>
                                <option value="estoqueBaixo">Estoque Baixo</option>
                                <option value="semEstoque">Sem Estoque</option>
                                <option value="inativo">Inativo</option>
                            </Form.Control>
                        </Form.Group>
                        
                        <SelecionarCategoriaProduto label="Filtrar por Categoria" defaultText="Todas" adicionalText="Sem categoria" adicionalValue="sem_categoria" categoriaId={filtroCategoria} setCategoriaId={setFiltroCategoria} />
                        
                        <Button variant="secondary" onClick={() => buscarProdutos(true)} disabled={loading} className="mt-2 w-100">
                            Buscar
                        </Button>
                      </>
                    )}
                </Form>

                <div id="listaCkProdutos" className="list-group mt-3">
                    {produtos.length > 0 ? (
                        produtos.map((x) => (
                          <RenderizarProduto
                            key={x.id}
                            //onClick2={() => teste()}
                            onClick2={() => addOrUpdateProduto(x, -1)}
                            onClick3={() => addOrUpdateProduto(x, 1)}
                            //to={`/produtos/${x.id}`}
                            src={x.foto_do_produto}
                            col2={getItem(x) ?"col-auto":""}
                            titulo3={`${getItem(x)?getItem(x).quantidade+'x':''}`}
                            //text3="Selecionado"
                            bcolor={getCor(x)}
                            lm='mb-1'
                            //icon:'bi-box-seam text-muted'
                            titulo={x.nome_do_produto}
                            text2={parseFloat(x.preco_de_venda).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            text4={`${x.controlar_estoque?`${x.quantidade_em_estoque} unidades em estoque`:''}`}
                          />
                        ))
                    ) : (
                        !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
            <MenuRodape venda={venda} botao={botao}/>
        </>
    );
};

export default SelecionarProdutos;